import { createActionCreator } from "common/ReduxUtils";
import { StorageFromAddressActionTypes } from "../StorageAddressAction.types";

export const setIsLimitedAccess = createActionCreator<boolean>(
  StorageFromAddressActionTypes.STORAGE_SET_IS_LIMITED_ACCESS,
  "isLimitedAccess"
);
